// M004-F0764 (WebUI #237): the room capability read. A caller admitted to /app/admin/rooms
// by the capability room_devices_read (not by an admin role) gets the room tabs and the
// Overview sub-tab, read-only. Visibility is decided from the caller's own capability map
// (GET /users/me/system-permissions), never from a role name (M001-D013).
export const CAPABILITY = 'room_devices_read';

export const hasCapability = (permissions, name = CAPABILITY) => permissions?.[name] === true;
